const organizationSubType = {
    AGENCY_BRANCH : 1,

    CARRIER_BRANCH : 2,

    MGA_CARRIER_BRANCH : 3,

    MGA_AGENCY_BRANCH : 4

};

angular.module('gw-um-j2js')
    .constant('organizationSubType', organizationSubType);